
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
import KeywordProtectedPage from './MyPage';

function Bestcabservice() {



    const cardData =
    {
        keyword: 'Best Cab Service For Matheran',
        heading: 'Mauli Cabs:  Best Cab Service For Matheran',
        headingDescription: 'Mauli Cabs offers the best cab service for Matheran, ensuring a comfortable and stress-free journey to this serene, vehicle-free hill station. Whether you are planning a peaceful retreat, a family trip, or a quick weekend escape, we provide a range of vehicles including sedans, SUVs, and premium cars. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a smooth travel experience right up to Matheran’s entry point.',

        top: 'Top Places to Visit in Matheran with Mauli Cabs',

"topPlaces": [
    {
        "title": "Echo Point",
        "description": "Echo Point is famous for its natural echo phenomenon and breathtaking panoramic views. It's a popular spot for shouting into the valley and hearing your voice bounce back."
    },
    {
        "title": "Louisa Point",
        "description": "Louisa Point offers stunning views of waterfalls, lush valleys, and the ruins of Prabal Fort. It’s one of the best sunset and sightseeing points in Matheran."
    },
    {
        "title": "Charlotte Lake",
        "description": "A serene and scenic lake, Charlotte Lake is the main source of drinking water for Matheran. It's a peaceful spot for picnics and nature walks, surrounded by dense greenery."
    },
    {
        "title": "Panorama Point",
        "description": "Panorama Point is known as the 'Sunrise Point' of Matheran. It offers 360-degree views of the Western Ghats and is perfect for witnessing stunning sunrises and sunsets."
    },
    {
        "title": "One Tree Hill Point",
        "description": "This unique hilltop is named after the single tree standing proudly at the summit. It offers beautiful views and a peaceful trekking experience through lush landscapes."
    },
    {
        "title": "Porcupine Point (Sunset Point)",
        "description": "Porcupine Point is a perfect place to witness a mesmerizing sunset over the valleys. The view of Prabalgad Fort from here adds to the charm of this picturesque location."
    },
    {
        "title": "Alexander Point",
        "description": "Alexander Point offers stunning views of the Garbut Point, Chowk Point, and the winding Ulhas River. It's a tranquil spot ideal for photography and quiet reflection."
    },
    {
        "title": "Monkey Point",
        "description": "True to its name, Monkey Point is known for its playful monkey population and beautiful valley views. It’s a fun stop while exploring Matheran’s many viewpoints."
    },
    {
        "title": "Pisarnath Temple",
        "description": "Dedicated to Lord Shiva, Pisarnath Temple is the oldest temple in Matheran. Located near Charlotte Lake, it offers a peaceful spiritual experience amidst nature."
    },
    {
        "title": "Matheran Toy Train",
        "description": "The Matheran Toy Train offers a delightful journey through dense forests, winding hills, and scenic landscapes. It's a nostalgic and charming way to experience Matheran’s beauty."
    }
],

"services": [
    {
        "name": "Matheran Cab Service",
        "description": "Mauli Cabs offers dependable cab services to Matheran. Whether you're planning a weekend getaway or a peaceful retreat, enjoy a safe and pleasant ride with our professional drivers."
    },
    {
        "name": "Book Taxi to Matheran",
        "description": "Book your taxi to Matheran easily with Mauli Cabs. We provide seamless booking and reliable transportation for individuals, families, and groups."
    },
    {
        "name": "Affordable Taxi for Matheran",
        "description": "Looking for a budget-friendly way to reach Matheran? Mauli Cabs offers affordable taxi services that ensure comfort and value for your trip."
    },
    {
        "name": "Private Cab Service for Matheran from Pune",
        "description": "Mauli Cabs offers private cab services from Pune to Matheran for travelers seeking a quiet and personalized experience. Travel at your own pace in comfort and privacy."
    },
    {
        "name": "Matheran Trip by Cab from Pune",
        "description": "Plan your Matheran trip with Mauli Cabs for a hassle-free and scenic journey from Pune. Our well-maintained vehicles ensure a relaxing travel experience."
    },
    {
        "name": "Group Travel to Matheran",
        "description": "Traveling in a group? Mauli Cabs has spacious vehicles perfect for group travel to Matheran, making your trip fun, coordinated, and comfortable."
    },
    {
        "name": "Luxury Taxi for Matheran",
        "description": "Travel in style to Matheran with Mauli Cabs' luxury taxi options. Our premium cabs provide a first-class experience for a scenic and relaxing journey."
    },
    {
        "name": "Comfortable Taxi Ride to Matheran",
        "description": "Enjoy a comfortable and safe ride to Matheran with Mauli Cabs. Our taxis are clean, air-conditioned, and driven by courteous professionals."
    },
    {
        "name": "Matheran Sightseeing by Taxi",
        "description": "Explore the hill station of Matheran with Mauli Cabs' sightseeing taxi services. Our knowledgeable drivers help you cover all the must-visit spots comfortably."
    },
    {
        "name": "Private Taxi for Matheran Vacation",
        "description": "Book a private taxi for your Matheran vacation with Mauli Cabs. Enjoy personalized service and stress-free travel tailored to your holiday plans."
    }
],

"tableData": [
    ["Matheran Cab Service", "Book Taxi to Matheran"],
    ["Affordable Taxi for Matheran", "Private Cab Service for Matheran from Pune"],
    ["Matheran Trip by Cab from Pune", "Group Travel to Matheran"],
    ["Luxury Taxi for Matheran", "Comfortable Taxi Ride to Matheran"],
    ["Matheran Sightseeing by Taxi", "Private Taxi for Matheran Vacation"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers the best cab service for your trip to Matheran. Whether you're traveling for a weekend getaway or a scenic adventure, our drivers ensure timely pickups and drop-offs, helping you enjoy your trip without any delays."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your journey to Matheran, Mauli Cabs provides a variety of vehicles designed for comfort. From sedans to SUVs and premium cars, all our vehicles come with air conditioning, spacious interiors, and ample legroom to ensure a comfortable ride."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced, professional, and well-acquainted with the routes leading to Matheran. They ensure your journey is smooth, safe, and pleasant, knowing the best routes and local conditions to make your trip hassle-free."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs provides the best cab service for Matheran at competitive prices. We offer transparent and affordable pricing with no hidden charges, ensuring you get the best value for your trip to the scenic hill station."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our top priority. All our vehicles are regularly serviced and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a secure and comfortable ride to Matheran."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "No matter when you're planning your trip to Matheran, Mauli Cabs is available 24/7. Our customer service team is always ready to assist you with your booking, ensuring that you have access to a reliable cab service anytime."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your cab for Matheran with Mauli Cabs is quick and hassle-free. You can easily book your ride online through our website or mobile app, or contact our customer service team for personalized assistance with your reservation."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you're visiting Matheran for a family outing, a romantic trip, or a solo adventure, Mauli Cabs offers customized travel packages to suit your needs. Share your preferences with us, and we’ll tailor your journey to make it even more memorable."
    }
]








    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Matheran with Mauli Cabs?',
            answer: 'Booking your cab is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Matheran as your destination, then choose the vehicle that fits your needs. Alternatively, you can call our support team for assistance.',
        },
        {
            question: 'What types of cabs are available for Pune to Matheran?',
            answer: 'Mauli Cabs offers a variety of vehicles, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. Choose the one that best suits your comfort and space requirements for the scenic trip to Matheran.',
        },
        {
            question: 'Is the fare from Pune to Matheran fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges. You will know the total fare upfront, with no hidden costs.',
        },
        {
            question: 'Can I book a round trip from Pune to Matheran?',
            answer: 'Yes, you can easily book both one-way and round-trip rides. Just provide your return details when making the booking, and we’ll ensure a smooth return journey.',
        },
        {
            question: 'How long does the journey from Pune to Matheran take?',
            answer: 'The ride from Pune to Matheran typically takes around 2.5 to 3 hours, depending on road and traffic conditions. We ensure a smooth and enjoyable journey through the scenic hills.',
        },
        {
            question: 'Are your drivers experienced with the Pune to Matheran route?',
            answer: 'Yes, our drivers are well-trained, experienced, and familiar with the best routes to Matheran, ensuring a safe and pleasant ride through the hilly terrain.',
        },
        {
            question: 'Can I book a cab for sightseeing around Matheran?',
            answer: 'Yes, Mauli Cabs offers customized sightseeing tours around Matheran. Whether you want to explore the famous viewpoints, lakes, or historical spots, our drivers will guide you through the best places.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained?',
            answer: 'Yes, all our cabs are fully air-conditioned and well-maintained for a comfortable and clean journey. We prioritize hygiene and comfort for an enjoyable trip to Matheran.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. Our flexible cancellation policy is available through our website or app, and our customer support team is always available to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Matheran trip?',
            answer: 'Mauli Cabs offers competitive pricing, a range of vehicle options, professional drivers, and reliable service. Whether for a relaxing getaway or a family trip, we ensure a comfortable and hassle-free journey to Matheran.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rajesh Patil",
            position: "Nature Lover",
            text: "Our trip to Matheran was incredible! The cab was comfortable, and the driver was very knowledgeable about the route. We had a peaceful, scenic drive to Matheran and enjoyed every moment. Highly recommend Mauli Cabs!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Rina Shah",
            position: "Weekend Traveler",
            text: "The ride to Matheran was smooth, and we had a great time exploring the hill station. The driver was friendly, and the vehicle was clean and well-maintained. Mauli Cabs made the trip so much easier!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Best Cab Service for Matheran by Mauli Cabs",
        "description": "Mauli Cabs offers the best cab service for Matheran with options for private, luxury, or group travel. Book your affordable and comfortable ride from Pune for sightseeing or a peaceful vacation. 24x7 online booking available.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.6",
          "ratingCount": "3100"
        }
      };
      
      
      


    return (
        <div>
            <GTag/>
<KeywordProtectedPage/>
<Helmet>
        <title>Best Cab Service for Matheran | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book the best cab service to Matheran from Pune with Mauli Cabs. Affordable and comfortable private, luxury, or group taxi options available with 24x7 online booking support."
        />
        <meta
          name="keywords"
          content="Matheran cab service, Book taxi to Matheran, Affordable taxi for Matheran, Private cab service for Matheran from Pune, Matheran trip by cab from Pune, Group travel to Matheran, Luxury taxi for Matheran, Comfortable taxi ride to Matheran, Matheran sightseeing by taxi, Private taxi for Matheran vacation"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/7.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bestcabservice;